import {
  Component,
  Inject,
  InjectionToken,
  OnInit,
  PLATFORM_ID,
  Renderer2
} from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import 'zone.js';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MessagingService } from './services/messaging.service';
import { environment } from '../environments/environment';
import { CommonService } from './services/common.service';
import { SwUpdate } from '@angular/service-worker';
import { NewsletterPopupComponent } from './pages/after-login-page/home/newsletter-popup/newsletter-popup.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'xplora-website-root',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    TranslateModule,
    HttpClientModule,
    NgxUiLoaderModule
  ],
  providers: [TranslateService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'xplora-website';
  protected selectedLanguage: string | null = null;
  showUpdateNotification = false; // Flag for update notification

  constructor(
    public translate: TranslateService,
    public router: Router,
    private _messagingService: MessagingService,
    private _commonService: CommonService,
    private renderer: Renderer2,
    private dialog: MatDialog,
    @Inject(PLATFORM_ID) private platformId: InjectionToken<object>,
    private swUpdate: SwUpdate
  ) {
    translate.addLangs(['en', 'ar']);
    if (isPlatformBrowser(this.platformId)) {
      this.selectedLanguage = localStorage.getItem(environment.langKey)
        ? localStorage.getItem(environment.langKey)
        : 'en';
      this._commonService.selectedLanguage.next(
        this.selectedLanguage ? this.selectedLanguage : 'en'
      );
      this.translate.setDefaultLang(
        this.selectedLanguage ? this.selectedLanguage : 'en'
      );
      document.documentElement.lang = this.selectedLanguage
        ? this.selectedLanguage
        : 'en';

      // Add or remove the 'rtl' class based on the selected language
      this.toggleBodyClass(this.selectedLanguage ? this.selectedLanguage : '');

      // Listen for language change
      this._commonService.selectedLanguage.subscribe((lang: any) => {
        if (lang && lang !== this.selectedLanguage) {
          this.selectedLanguage = lang;
          if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem(environment.langKey, lang);
            this.toggleBodyClass(lang);
            window.location.reload();
          }
        }
      });
    }
  }
  ngOnInit(): any {
    if (isPlatformBrowser(this.platformId)) {
      const isLoggedIn =
        localStorage.getItem('XPW_ST_K_P') ||
        sessionStorage.getItem('newsletterDismissed');
      // if (!isLoggedIn) {
      //   setTimeout(() => {
      //     this.dialog.open(NewsletterPopupComponent, {
      //       panelClass: 'popup-dialog-panel',
      //       backdropClass: 'custom-backdrop'
      //     });
      //   }, 30000);
      // }
    }
    this.router.events.subscribe((evt: any) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      if (isPlatformBrowser(this.platformId)) {
        window.scrollTo(0, 0);
      }
    });
    if (isPlatformBrowser(this.platformId)) {
      this._messagingService.requestPer();
      this._messagingService.listenForFrontMessages();
      this.translate.get('notificationAlert').subscribe(() => {
        if (
          Notification.permission === 'denied' &&
          this.translate.store.translations
        ) {
          // alert(this.translate.instant('notificationAlert'));
        }
      });
      // Check for app updates
      if (this.swUpdate.isEnabled) {
        this.swUpdate.versionUpdates.subscribe(event => {
          if (event.type === 'VERSION_READY') {
            this.showUpdateNotification = true;
          }
        });
      }
      // this.loadGTM();
    }
  }
  // loadGTM() {
  //   const script = this.renderer.createElement('script');
  //   script.type = 'text/javascript';
  //   script.async = true;
  //   script.src = 'https://hdaqnazi.me.stape.io/gtm.js?id=GTM-TNRPLJ4G';
  //   this.renderer.appendChild(document.body, script);
  // }

  reloadPage(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.location.reload();
    }
  }

  private toggleBodyClass(lang: string): void {
    const body = document.body;
    if (lang === 'ar') {
      body.classList.add('rtl');
    } else {
      body.classList.remove('rtl');
    }
  }
}
